import { UserInfo } from '../../features/userInfo/models/userInfo';
import { UserInfoService } from '../../features/userInfo/services/UserInfoService';


export class FeatureDisabledForDirective implements angular.IDirective {
    restrict = 'A';
    role: string;
    constructor(private userInfoService: UserInfoService, private $q: ng.IQService, $rootScope: ng.IRootScopeService) {
        
    }

    link = (scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: ng.IAttributes) => {
        scope.$watch(() => { return UserInfoService.stuInfo; }, (newValue, oldValue) => {
            if (newValue !== undefined && newValue.role === attrs["featureDisabledFor"].trim()) {
                element.remove();
            } 
        });

    };

    static factory(): angular.IDirectiveFactory {
        var directive = (userInfoService: UserInfoService, $q: ng.IQService, $rootScope: ng.IRootScopeService) => new FeatureDisabledForDirective(userInfoService, $q, $rootScope);
        directive.$inject = ['UserInfoService', '$q', '$rootScope'];
        return directive;
    }
}

angular.module('deliveryCreate.app').directive('featureDisabledFor', FeatureDisabledForDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/featureroles/featureDisabledFor.ts
 **/